import { isNil } from 'lodash';
import { useEffect, useMemo } from 'react';
import { useBoolean } from '@shared/util/hooks';

const LONG_PRESS_DELAY_MS = 1000;

export interface LongPressProps {
  onPointerDown: VoidFunction;
  onPointerUp: VoidFunction;
  onPointerLeave: VoidFunction;
}

export function useLongPress(onLongPress: VoidFunction | undefined): LongPressProps | undefined {
  const [isPointerDown, onPointerDown, onPointerUp] = useBoolean(false);

  useEffect(() => {
    if (isPointerDown && !isNil(onLongPress)) {
      const timer = setTimeout(() => onLongPress?.(), LONG_PRESS_DELAY_MS);
      return () => clearTimeout(timer);
    }
  }, [isPointerDown, onLongPress]);

  return useMemo(() => {
    if (isNil(onLongPress)) {
      return undefined;
    }
    return {
      onPointerDown,
      onPointerUp,
      onPointerLeave: onPointerUp,
    };
  }, [onPointerDown, onPointerUp, onLongPress]);
}
